import {
  all,
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import { get, putRequest } from '../../../utils/request';
import { parseScheduleReasons } from './helpers';
import {
  amortizeCalculateFailure,
  amortizeCalculateSuccess,
  amortizeStatusFailure,
  amortizeStatusSuccess,
} from './actions';
import {
  AMORTIZE_CALCULATE,
  AMORTIZE_DEFAULT_ERROR_MESSAGE,
  AMORTIZE_STATUS,
  AMORTIZE_UNAVAILABLE_ERROR_MESSAGE,
} from './constants';

export function* amortizeCalculateSaga(
  { baseUrl },
  { payload },
) {
  const { calculateStatus, loanNumber, requestBody } = payload;
  try {
    const endpoint = `${baseUrl}/schedules/${loanNumber}`;
    const { currentSetting, error, payments } = yield call(putRequest, endpoint, requestBody);
    if (error) {
      const { reasons } = error;
      const parsedReasons = parseScheduleReasons(reasons);
      yield put(amortizeCalculateFailure(calculateStatus, parsedReasons));
    } else {
      yield put(amortizeCalculateSuccess({ calculateStatus, currentSetting, payments }));
    }
  } catch {
    yield put(amortizeCalculateFailure(calculateStatus, { error: AMORTIZE_DEFAULT_ERROR_MESSAGE }));
  }
}

export function* amortizeStatusSaga({ baseUrl }, { payload }) {
  const { loanNumber } = payload;
  try {
    const endpoint = `${baseUrl}/schedules/${loanNumber}`;
    const {
      currentSetting,
      error,
      payments,
      prePopulatedAmortizationFields,
    } = yield call(get, endpoint);
    if (error) {
      yield put(amortizeStatusFailure(AMORTIZE_UNAVAILABLE_ERROR_MESSAGE));
    } else {
      yield put(amortizeStatusSuccess(
        { currentSetting, payments, prePopulatedAmortizationFields },
      ));
    }
  } catch {
    yield put(amortizeStatusFailure(AMORTIZE_DEFAULT_ERROR_MESSAGE));
  }
}

const matchCalculatorType = (calculatorType) => (action) => {
  const { payload: { calculateStatus } = {}, type: actionType } = action;
  return (actionType === AMORTIZE_CALCULATE && calculateStatus === calculatorType);
};

export default (options) => function* watcherSaga() {
  yield all([
    takeLatest(matchCalculatorType('amortization'), amortizeCalculateSaga, options),
    takeLatest(matchCalculatorType('payLumpSum'), amortizeCalculateSaga, options),
    takeLatest(matchCalculatorType('payMoreMonthly'), amortizeCalculateSaga, options),
    takeLatest(AMORTIZE_STATUS, amortizeStatusSaga, options),
  ]);
};
